export const Aria = [
  {
    name: "Connection from ARIA to Vdara",
    level: "area_level_1",
    poiId: "aria_connection_from_aria_vidara",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Aria1",
  },
  {
    name: "Hotel Check In/Lobby",
    level: "area_level_1",
    poiId: "lobby",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Aria1",
  },
  {
    name: "Guest Elevators",
    level: "",
    poiId: "aria_guest_elevators",
    dollhousemapId: "DlHse_RO_Aria_L2",
    isActive: false,
    map: "Aria1",
  },
  // {
  //   name: "East Convention Center",
  //   level: "area_level_2",
  //   poiId: "aria_east_convention_center",
  //   dollhousemapId: "DlHse_RO_Aria_L2",
  //   isActive: false,
  //   map: "Aria2",
  // },
  {
    name: "Convention Area",
    level: "area_level_2",
    poiId: "aria_west_convention_center",
    dollhousemapId: "DlHse_RO_Aria_L2",
    isActive: false,
    map: "Aria2",
  },
  {
    name: "Tram Entry/Hallway to Park MGM/T-Mobile Arena",
    level: "area_level_1",
    poiId: "park_mgm_entry_point",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Aria1",
  },
  {
    name: "Pool",
    level: "area_level_2",
    poiId: "aria_pool_area",
    dollhousemapId: "DlHse_RO_Aria_L2",
    isActive: false,
    map: "Aria2",
  },
  {
    name: "Restaurants",
    level: "",
    poiId: "aria_level_restaurent",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Aria1",
  },
  {
    name: "The Spa at ARIA",
    level: "area_level_2",
    poiId: "aria_spa_area",
    dollhousemapId: "DlHse_RO_Aria_L2",
    isActive: false,
    map: "Aria2",
  },
];

export const Vdara = [
  // {
  //   name: "Connection to Bellagio Bridge/The Cosmpolitan of Las Vegas",
  //   level: "",
  //   poiId: "vdara_connection_bellagio",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: false,
  //   map: "Vdara",
  // },
  {
    name: "Hotel Check In/Lobby",
    level: "",
    poiId: "vdara_registeration",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Vdara",
  },
  {
    name: "Guest Elevators",
    level: "",
    poiId: "vdara_guest_elevators",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Vdara",
  },
  {
    name: "Convention Area",
    level: "",
    poiId: "vdara_vinoly",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Vdara",
  },
  // {
  //   name: "Silk Road Meeting Space",
  //   level: "",
  //   poiId: "vdara_silkroad",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: false,
  //   map: "Vdara",
  // },
  // {
  //   name: "Vice Versa",
  //   level: "",
  //   poiId: "vdara_vice_versa",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: false,
  //   map: "Vdara",
  // },
  // {
  //   name: "Pool & Cabanas",
  //   level: "",
  //   poiId: "",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: true,
  //   map: "Vdara",
  // },
  {
    name: "Restaurants",
    level: "",
    poiId: "vdara_restaurent",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Vdara",
  },
  {
    name: "Walkway to ARIA",
    level: "",
    poiId: "vdara_walkway_to_aria",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Vdara",
  },
  // {
  //   name: "Spa/Fitness Center",
  //   level: "",
  //   poiId: "",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: true,
  //   map: "Vdara",
  // },
];

export const Bellagio = [
  {
    name: "Tram Entry Point",
    level: "",
    poiId: "bellagio_tram_point",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Bellagio",
  },
  {
    name: "Hotel Check In/Lobby",
    level: "",
    poiId: "bellagio_hotel_check_in",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Bellagio",
  },
  {
    name: "Guest Elevator",
    level: "",
    poiId: "bellagio_guest_elevator",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Bellagio",
  },
  {
    name: "Fountains of Bellagio",
    level: "",
    poiId: "bellagio_fountains",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Bellagio",
  },
  {
    name: "Convention Area",
    level: "",
    poiId: "bellagio_convention",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Bellagio",
  },
  // {
  //   name: "Spa Tower Entrance",
  //   level: "",
  //   poiId: "bellagio_spa_tower_entrance",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: false,
  //   map: "Bellagio",
  // },
  {
    name: "Pool",
    level: "",
    poiId: "bellagio_pool",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Bellagio",
  },
  {
    name: '"O" Theatre',
    level: "",
    poiId: "bellagio_dolby_theatre",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Bellagio",
  },
  {
    name: "The Conservatory",
    level: "",
    poiId: "bellagio_conservatory",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Bellagio",
  },
  {
    name: "Restaurants",
    level: "",
    poiId: "bellagio_restaurent",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Bellagio",
  },
  // {
  //   name: "Entrance Point to Vdara",
  //   level: "",
  //   poiId: "bellagio_entrance_point_vdara",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: false,
  //   map: "Bellagio",
  // },
  {
    name: "Spa/Fitness Center",
    level: "",
    poiId: "bellagio_spa",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Bellagio",
  },
];

export const ParkMGM = [
  {
    name: "Tram Entry Point",
    level: "",
    poiId: "park_mgm_entry_point",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "ParkMgm",
  },
  {
    name: "Hotel Check In/Lobby",
    level: "",
    poiId: "park_mgm_lobby",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "ParkMgm",
  },
  {
    name: "Guest Elevators",
    level: "",
    poiId: "park_mgm_elevators",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "ParkMgm",
  },
  // {
  //   name: "Dolby Live Theater",
  //   level: "",
  //   poiId: "park_mgm_dolby_live",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: false,
  //   map: "ParkMgm",
  // },
  {
    name: "Convention Area",
    level: "",
    poiId: "park_mgm_convention_area",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "ParkMgm",
  },
  {
    name: "Pool",
    level: "",
    poiId: "park_mgm_pool",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "ParkMgm",
  },
  {
    name: "Restaurants",
    level: "",
    poiId: "park_mgm_restaurent",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "ParkMgm",
  },
  {
    name: "Entrance Point to ARIA",
    level: "",
    poiId: "park_mgm_entrance_point_to_aria",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "ParkMgm",
  },
  // {
  //   name: "Spa/Fitness Center",
  //   level: "",
  //   poiId: "",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: true,
  //   map: "ParkMgm",
  // },
];

export const TCOLV = [
  {
    name: "Walkway from ARIA",
    level: "cosmo_level_2",
    poiId: "cosmo_walkway_aria",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Tcolv",
  },
  {
    name: "Hotel Check In/Lobby",
    level: "cosmo_level_1",
    poiId: "cosmo_check_in",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Tcolv",
  },
  {
    name: "Guest Elevators",
    level: "",
    poiId: "cosmo_guest_elevators",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Tcolv",
  },
  {
    name: "Convention Area - Level 2",
    level: "cosmo_level_2",
    poiId: "cosmo_convention_area_2",
    dollhousemapId: "DlHse_RO_L1_wTCOLV_L2",
    isActive: false,
    map: "Tcolv",
  },
  {
    name: "Convention Area - Level 3",
    level: "cosmo_level_3",
    poiId: "cosmo_convention_area_3",
    dollhousemapId: "DlHse_RO_TCOLV_L3",
    isActive: false,
    map: "Tcolv",
  },
  {
    name: "Convention Area - Level 4",
    level: "cosmo_level_4",
    poiId: "cosmo_convention_area_4",
    dollhousemapId: "DlHse_RO_TCOLV_L4",
    isActive: false,
    map: "Tcolv",
  },
  {
    name: "The Chelsea",
    level: "cosmo_level_3",
    poiId: "cosmo_chelsea_theatre",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Tcolv",
  },
  {
    name: "Boulevard Pool",
    level: "cosmo_level_4",
    poiId: "cosmo_pool",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Tcolv",
  },
  // {
  //   name: "Spa/Fitness Center",
  //   level: "cosmo_level_1",
  //   poiId: "",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: true,
  //   map: "Tcolv",
  // },
  // {
  //   name: "Reception suite",
  //   level: "cosmo_level_1",
  //   poiId: "",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: false,
  //   map: "Tcolv",
  // },
  {
    name: "Restaurants",
    level: "",
    poiId: "cosmo_district",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Tcolv",
  },
];

export const DistrictHighlight = [
  {
    name: "Tram Path",
    level: "",
    poiId: "district_highlight_tram_path",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "DistrictHighlight",
  },
  {
    name: "Bridge",
    level: "",
    poiId: "district_highlight_bridge_connection_1",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "DistrictHighlight",
  },
  {
    name: "Shuttle Path",
    level: "",
    poiId: "district_highlight_shuttle_stop",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "DistrictHighlight",
  },
  {
    name: "Walkway",
    level: "",
    poiId: "district_highlight_bridge_connection_2",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "DistrictHighlight",
  },
  // {
  //   name: "T Mobile Arena",
  //   level: "",
  //   poiId: "district_highlight_t_mobile",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: false,
  //   map: "DistrictHighlight",
  // },
  // {
  //   name: "Dolby Live Theater",
  //   level: "",
  //   poiId: "park_mgm_dolby_live",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: false,
  //   map: "DistrictHighlight",
  // },
];

export const Nomad = [
  {
    name: "Elevators",
    level: "",
    poiId: "no_mad_elevators",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Nomad",
  },
  // {
  //   name: "NoMad Bar",
  //   level: "",
  //   poiId: "no_mad_bar",
  //   dollhousemapId: "DlHse_RO_Aria_L1",
  //   isActive: false,
  //   map: "Nomad",
  // },
  {
    name: "NoMad Lobby",
    level: "",
    poiId: "park_mgm_no_mad_lobby",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Nomad",
  },
  {
    name: "NoMad Library Restaurant",
    level: "",
    poiId: "no_mad_library",
    dollhousemapId: "DlHse_RO_Aria_L1",
    isActive: false,
    map: "Nomad",
  },
];
